import { render, staticRenderFns } from "./ChannelExposure.vue?vue&type=template&id=53b233fa"
import script from "./ChannelExposure.vue?vue&type=script&lang=js"
export * from "./ChannelExposure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports